import "./Widgets.css";
import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import {
  TwitterTweetEmbed,
  TwitterTimelineEmbed,
  TwitterShareButton,
} from "react-twitter-embed";

function Widgets() {
  return (
    <div className="widgets">
      <div className="widgets__input">
        <SearchIcon className="widgets__searchIcon" />
        <input placeholder="Search Twitter" type="text" />
      </div>

      <div className="widgets__widgetContainer">
        <h2>What's happening</h2>

        <TwitterTweetEmbed
          tweetId={"1293149090059034625"}
          options={{ height: 200 }}
        />

        {/* <TwitterTimelineEmbed
          sourceType="profile"
          screenName="_heemo_"
          options={{ height: 400 }}
        /> */}

        <TwitterShareButton
          url={"https://linkedin.com/in/ibrahim-abouelezz"}
          options={{ text: "Connect with me on LinkedIn", via: "_heemo_" }}
        />
      </div>
    </div>
  );
}

export default Widgets;
